import { AxiosInstance, AxiosRequestConfig } from 'axios';

export interface ConveyrRequestConfig {
    notify?: boolean;
    signal?: AbortSignal;
    // Scope every request made through this API instance to a specific merchant, instead of
    // the ambient one the interceptor would stamp on. Lets a deferred/batched request pin its
    // merchant up front (see the query resolvers): `API({ merchantId }).x.fetch(...)`.
    merchantId?: number;
    // Same as merchantId, for the service provider header.
    serviceProviderId?: number;
}

/**
 * Creates an axios-like wrapper that injects custom config into all requests
 */
export function createAxiosWithConfig(
    axiosInstance: AxiosInstance,
    config: ConveyrRequestConfig,
): AxiosInstance {
    const mergeConfig = (requestConfig?: AxiosRequestConfig): AxiosRequestConfig => {
        return {
            ...requestConfig,
            signal: requestConfig?.signal ?? config.signal,
            __conveyrRequestConfig: config,
        };
    };

    const wrapped: AxiosInstance = Object.assign({}, axiosInstance, {
        get: (url: string, cfg?: AxiosRequestConfig) =>
            axiosInstance.get(url, mergeConfig(cfg)),

        post: (url: string, data?: unknown, cfg?: AxiosRequestConfig) =>
            axiosInstance.post(url, data, mergeConfig(cfg)),

        put: (url: string, data?: unknown, cfg?: AxiosRequestConfig) =>
            axiosInstance.put(url, data, mergeConfig(cfg)),

        patch: (url: string, data?: unknown, cfg?: AxiosRequestConfig) =>
            axiosInstance.patch(url, data, mergeConfig(cfg)),

        delete: (url: string, cfg?: AxiosRequestConfig) =>
            axiosInstance.delete(url, mergeConfig(cfg)),
    });
    return wrapped;
}
